import script from "./DeleteJobConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeleteJobConfirmDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./DeleteJobConfirmDropdown.vue?vue&type=style&index=0&id=4da54550&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da54550"]])

export default __exports__